import * as moment from "moment-timezone";
import * as React from "react";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { InfoBar } from "src/library/components/InfoBar";
import { getNotificationAudienceText } from "src/core/notifications/utils";

import {
  INotification,
  INotificationRecipientsInfo,
  INotificationReadingInfo
} from "../api/notifications.api";

interface IProps {
  isLoading: boolean;
  notification?: Partial<INotification> | null;
  audienceInformation?: INotificationRecipientsInfo;
  primaryAction?: JSX.Element | null;
  secondaryAction?: JSX.Element | null;
  terminology: ITerminology;
  isValidAudienceInformation?: boolean;
  title?: string;
  readingInformation?: INotificationReadingInfo;
}

const NotificationInfoSidebar: React.ReactFCWithChildren<IProps> = ({
  isValidAudienceInformation = true,
  notification,
  isLoading,
  primaryAction,
  secondaryAction,
  terminology,
  audienceInformation,
  readingInformation,
  title = "Information"
}) => {
  const items: Array<{ label: string; value: string }> = [];

  if (notification) {
    if (notification.createdAt) {
      items.push({
        label: "Sent at",
        value: moment
          .utc(notification.createdAt)
          .local()
          .format("HH:mm DD MMMM YYYY")
      });
    }

    if (notification.notificationRecipients && notification.notificationRecipients.length && notification.notificationRecipients[ 0 ].type) {
      items.push({
        label: "Audience",
        value: getNotificationAudienceText(notification.notificationRecipients[ 0 ].type, terminology)
      });
    }
  }

  if (audienceInformation) {
    for (const info in audienceInformation) {
      const label =
        info === "usersCount" ?
          terminology.user.plural.text :
          info === "branchesCount" ?
            terminology.drop.plural.text :
            terminology.customer.plural.text;

      items.push({
        label,
        value: isValidAudienceInformation ? `${audienceInformation[ info as keyof INotificationRecipientsInfo ]} ${label}` : "-"
      });
    }
  }

  if (readingInformation) {
    for (const info in readingInformation) {
      const label = info === "usersCount" ? "Sent to" : "Read by";

      items.push({
        label,
        value: `${readingInformation[ info as keyof INotificationReadingInfo ]} ${terminology.user.plural.text}`
      });
    }
  }

  return (
    <InfoBar
      title={title}
      isLoading={isLoading}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      items={items}
    />
  );
};

export default NotificationInfoSidebar;
